export interface Item {
  id: number;
  name: string;
  nameAr: string;
}
export enum LanguageEnum {
  en = "en", 
  ar = "ar"
}
